import axios from "axios";
import Coureur from "../Coureurs/Coureur.class.js";
import List_Courses from "../Courses/List_Courses.class";
import List_Packs_Courses from "../Packs_Courses/List_Packs_Courses.class.js";
import UserService from "@/services/user.service";
import AdminService from "@/services/admin.service.js";

/**
 * @classdesc La fiche coureur d'une inscription à un module
 * @kind class
 * @export

 * @class Inscription
 */
export default class Inscription {
    id;
    id_module;
    id_account;
    id_course;
    dossard;
    nom;
    prenom;
    sexe;
    club;
    date_naissance;
    id_coureur;
    id_commande_inscription;
    id_commande;
    inscription_sportive;
    id_vague_course;
    affiche;
    paye;
    document_recu;
    document_valide;
    valide;
    champs;
    coureur;
    course;
    gia;
    alerte_sms;
    donation;
    supprime;
    transfere;
    from_transfert;
    commande_inscription;
    code_reduction;
    refunds;
    commande_options = [];
    list_courses = [];
    list_packs_courses = [];
    pending_payment_status;
    bourse_dossards_status;
    from_bourse_dossards;
    lien_privilegie;

    /**
     * Creates an instance of Inscription.
     * @constructs
     * @kind function
     * @memberof Inscription
     */
    constructor(id_module) {
        this.coureur = new Coureur();
        this.list_courses = new List_Courses(id_module);
        this.list_packs_courses = new List_Packs_Courses(id_module);
    }

    async get() {
        let res = await UserService.getInscription(this.id);
        if (res) { this.set(res); }
        return res;
    }

    async get_admin() {
        let res = await AdminService.getInscription(this.id);
        if (res) { this.set(res); }
        return res;
    }

    async get_by_token(token) {
        let res = await UserService.getInscriptionByToken(token);
        if (res) { this.set(res); }
        return res;
    }

    async update_informations() {
        let res = await UserService.updateInscriptionInformations(this);
        return res;
    }
    async update_informations_by_token(token) {
        let res = await UserService.updateInscriptionInformationsByToken(token, this);
        return res;
    }

    async update_document() {
        let res = await UserService.updateInscriptionDocument(this);
        return res;
    }

    async update_document_by_token(token) {
        let res = await UserService.updateInscriptionDocumentByToken(token, this);
        return res;
    }

    async send_transfert_request(mail_donneur, mail_recipient) {
        let data = {
            mail_donneur: mail_donneur,
            id_inscription: this.id,
            mail_recipient: mail_recipient,
        };
        let request = await UserService.sendTransfertRequest(data);
        return request;
    }

    async send_admin_transfert_request(mail_donneur, mail_recipient) {
        let data = {
            mail_donneur: mail_donneur,
            id_inscription: this.id,
            mail_recipient: mail_recipient,
        };
        let request = await AdminService.sendTransfertRequest(data);
        return request;
    }


    async fetch(mode = "default") {
        let res = await axios.get("/fiche_coureur/edit_coureur/get.php?id=" + this.id + "&mode=" + mode + "&id_account=" + this.id_account);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            this.set(res.data);
            return await true;
        }
    }



    set(data) {
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                if (key == "coureur") {
                    this.coureur.set_from_fiche_coureur(value);
                }
                else {
                    this[key] = value;
                }
            }
        }
    }

    has_document_asked() {
        console.log(this.champs);
    }


    async update_informations_coureur_admin(owner) {
        if (this.coureur.champs["nom"]) { this.nom = this.coureur.champs["nom"].value; }
        if (this.coureur.champs["prenom"]) { this.prenom = this.coureur.champs["prenom"].value; }
        if (this.coureur.champs["sexe"]) { this.sexe = this.coureur.champs["sexe"].value; }
        if (this.coureur.champs["date_naissance"]) { this.date_naissance = this.coureur.champs["date_naissance"].value; }
        if (this.coureur.champs["club"]) { this.club = this.coureur.champs["club"].value; }
        this.owner = owner;
        let res = await axios.post("/fiche_coureur/edit_coureur/update_admin.php", this);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            return await true;
        }
    }

    async update_options_coureur_admin(owner) {
        this.owner = owner;
        let res = await axios.post("/fiche_coureur/edit_coureur/update_options_admin.php", this);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        }
        else {
            return await true;
        }

    }

    align_coureur_infos_with_inscription() {
        for (const [key, value] of Object.entries(this.champs)) {
            if (this.coureur.champs[key]) {
                this.coureur.champs[key] = value;
            }
        }
    }
    populate_coureur_infos_with_inscription() {
        this.coureur.champs["nom"] = this.nom;
        this.coureur.champs["prenom"] = this.prenom;
        this.coureur.champs["sexe"] = this.sexe;
        this.coureur.champs["date_naissance"] = this.date_naissance;
        this.coureur.champs["club"] = this.club;
        for (const [key, value] of Object.entries(this.champs)) {

            this.coureur.champs[key] = value;

        }
    }

    set_selected_course() {
        this.list_courses.list.forEach((course) => {
            if (course.id == this.id_course) {
                course.selected = true;
                if (course.vagues && course.vagues.list) {
                    course.vagues.list.forEach((vague) => {
                        if (vague.id == this.id_vague_course) {
                            course.vague_selected = vague.id;
                            vague.selected = true;
                        }
                    });
                }
            }
        });
    }
}